<template>
  <div
    class="profile"
    v-if="
      $store.getters['auth/isRole']('ROLE_AGENT') == true ||
      $store.getters['auth/isRole']('ROLE_ADMIN') == true ||
      $store.getters['auth/isRole']('ROLE_SUPER_ADMIN') == true
    "
  >
    <div class="left-sidebar">
      <div class="left-sidebar__header">
        <img src="/static/img/pictos/compte.svg" class="" />
        <span>Mon compte</span>
      </div>
    </div>
    <div class="content-area">
      <h2>Mes identifiants</h2>

      <div class="info">
        <img src="/static/img/pictos/commandepar.svg" class="info__picto" />
        <span class="info__name">{{ user.firstname }} {{ user.lastname }}</span>
        <p class="info__secondary">
          Identifiant Gaïa : <span class="bleu">{{ user.id_gaia }}</span>
        </p>
      </div>

      <div class="info">
        <img src="/static/img/pictos/mail.svg" class="info__picto" />
        <span class="info__name">{{ user.email }}</span>
        <p class="info__secondary"></p>
      </div>

      <div class="info">
        <img src="/static/img/pictos/agence.svg" class="info__picto" />
        <span class="info__name">Agence : {{ user.agency.name }}</span>
        <p class="info__secondary" v-if="user.default_imputation">
          Code imputation : <span class="bleu">{{ user.default_imputation.code }}</span>
        </p>
      </div>

      <div class="info">
        <img src="/static/img/pictos/codevehicule.svg" class="info__picto" />
        <span class="info__name" v-if="user.vehicle">Nom du véhicule: {{ user.vehicle.name }}</span>
        <p class="info__secondary" v-if="user.vehicle">
          Code véhicule : <span class="bleu">{{ user.vehicle.code }}</span>
        </p>
      </div>

      <h2>Mon adresse de livraison</h2>

      <div class="info">
        <img src="/static/img/pictos/magasinstockssbulle.svg" class="info__picto" />
        <span class="info__name info__name--address" v-if="user.addresses[0]"
          ><strong>{{ user.addresses[0].street }}</strong
          >{{ user.addresses[0].zip_code }} {{ user.addresses[0].city }}</span
        >

        <!-- <router-link :to="{name: 'ChangeAddress'}" class="info__btn">
          Modifier
        </router-link> -->
      </div>
      <small class="text__red"
        ><i
          >Si cette adresse est incorrecte veuillez contacter le magasin ou la coordination</i
        ></small
      >

      <h2>Mes identifiants de connexion</h2>

      <div class="info">
        <img src="/static/img/pictos/commandepar.svg" class="info__picto" />
        <span class="info__name info__name--address"
          ><strong>{{ user.email }}</strong></span
        >
        <router-link
          :to="{ name: 'SecurityChangePassword' }"
          class="info__btn info__btn--pass-admin"
        >
          {{ $t("action.password.change") }}
        </router-link>
      </div>
    </div>
  </div>
  <div class="profile profile--mobile" v-else>
    <UserHeader></UserHeader>
    <div class="content-area">
      <h2>Mes identifiants</h2>

      <div class="info">
        <img src="/static/img/pictos/commandepar.svg" class="info__picto" />
        <div class="info__name">
          {{ user.firstname }} {{ user.lastname }}
          <div class="info__secondary">
            Identifiant Gaïa : <span class="bleu">{{ user.id_gaia }}</span>
          </div>
        </div>
      </div>

      <div class="info">
        <img src="/static/img/pictos/mail.svg" class="info__picto" />
        <div class="info__name">
          {{ user.email }}
        </div>
      </div>

      <div class="info">
        <img src="/static/img/pictos/agence.svg" class="info__picto" />
        <div class="info__name">
          Agence : {{ user.agency.name }}
          <div class="info__secondary" v-if="user.default_imputation">
            Code imputation : <span class="bleu">{{ user.default_imputation.name }}</span>
          </div>
        </div>
      </div>

      <div class="info">
        <img src="/static/img/pictos/codevehicule.svg" class="info__picto" />
        <div class="info__name">
          {{ user.vehicle.name }}
          <div class="info__secondary" v-if="user.vehicle">
            Code véhicule : <span class="bleu">{{ user.vehicle.code }}</span>
          </div>
        </div>
      </div>

      <h2>Mon adresse de livraison</h2>

      <div class="info">
        <img src="/static/img/pictos/magasinstockssbulle.svg" class="info__picto" />
        <span class="info__name info__name--address" v-if="user.addresses && user.addresses[0]"
          ><strong>{{ user.addresses[0].street }}</strong> {{ user.addresses[0].zip_code }}
          {{ user.addresses[0].city }}</span
        >

        <!-- <router-link :to="{ name: 'ChangeAddress' }" class="info__btn"> Modifier </router-link> -->
      </div>
      <small class="text__red"
        ><i
          >Si cette adresse est incorrecte veuillez contacter le magasin ou la coordination</i
        ></small
      >

      <h2>Mes indisponibilités</h2>

      <div
        class="info info--unavailability"
        v-for="unavailability in user.unavailabilities"
        v-if="!unavailability.deleted_at"
      >
        <img src="/static/img/pictos/indispo.svg" class="info__picto" />
        <span class="info__name"
          >du <strong>{{ unavailability.begin_date | moment("DD-MM-YYYY") }}</strong
          ><br />au <strong>{{ unavailability.end_date | moment("DD-MM-YYYY") }}</strong></span
        >
        <p class="info__secondary">
          {{ unavailability.end_date | (moment("diff", unavailability.begin_date, "days") + 1) }}
          jours
        </p>
        <a class="" @click.prevent="deleteUnavailability(unavailability.id)"
          ><img src="/static/img/pictos/supprimer.svg" class="delete"
        /></a>
      </div>

      <router-link :to="{ name: 'UserAddIndispo' }" class="info__btn info__btn--pass">
        {{ $t("action.indispo.add") }}
      </router-link>

      <h2>Mes identifiants de connexion</h2>

      <div class="info">
        <img src="/static/img/pictos/commandepar.svg" class="info__picto" />
        <span class="info__name info__name--address"
          ><strong>{{ user.email }}</strong></span
        >
      </div>
      <router-link :to="{ name: 'SecurityChangePassword' }" class="info__btn info__btn--pass">
        {{ $t("action.password.change") }}
      </router-link>
    </div>
  </div>
</template>

<script>
import UserHeader from "@/components/User/UserHeader";

export default {
  name: "Profile",
  components: {
    UserHeader,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    user: function () {
      let user = this.$store.getters["auth/user"];
      if (typeof user == "string") {
        return JSON.parse(user);
      } else {
        return user;
      }
    },
  },
  methods: {
    deleteUnavailability(id) {
      this.$http.delete("unavailability/" + id, {}).then((response) => {
        this.$store.dispatch("auth/getCurrentUser");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $grisclair;
  border-radius: 20px;
  height: 5px;
}

.profile {
  display: flex;
  &--mobile {
    flex-direction: column;
    .content-area {
      width: 100%;
      margin-right: 0;
      padding: 0 20px;
      margin-top: 30px;
      h2 {
        font-size: 16px;
        margin-bottom: 15px;
        &:last-of-type {
          margin-top: 30px;
        }
      }
      .info__picto {
        margin-right: 20px;
      }
      .info__name {
        width: auto;
        flex: 1;
      }
      .info {
        margin-bottom: 20px;
      }
      .text__red {
        color: $rouge;
      }
    }
  }
}
.left-sidebar {
  width: 300px;
  &__header {
    background-color: $color2;
    display: flex;
    height: 300px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 120px;
    }
    span {
      color: white;
      font-family: "ClanFFBlack";
      font-size: 20px;
      margin-top: 25px;
      text-transform: uppercase;
    }
  }
}
.content-area {
  width: calc(100% - 300px);
  padding: 0 7%;
  margin-top: 80px;
  margin-right: 50px;
  h2 {
    font-family: "ClanPro";
    color: $color1;
    font-size: 20px;
    margin-bottom: 50px;
    position: relative;
    padding-bottom: 5px;
    border-bottom: 1px solid $color2;
    margin-top: 40px;
    &:last-of-type {
      margin-top: 100px;
    }
    &:first-of-type {
      margin-top: 0;
    }
  }
}

.info {
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 40px;
  &__picto {
    width: 30px;
    margin-right: 50px;
  }
  &__name {
    font-family: "ClanPro";
    color: $color1;
    font-size: 14px;
    width: 220px;
    strong {
      font-family: "ClanProBold";
      font-weight: normal;
      font-size: 14px;
      display: block;
    }
    &--address {
      width: auto;
      flex: 1;
    }
  }
  &__btn {
    border: 1px solid $color2;
    color: $color2;
    text-align: center;
    height: 45px;
    line-height: 45px;
    padding: 0 20px;
    font-size: 12px;
    font-family: "ClanProBold";
    font-weight: normal;
    width: 150px;
    &:hover {
      text-decoration: none;
    }
    &--pass {
      width: 100%;
      display: block;
    }
    &--pass-admin {
      width: auto;
    }
  }
  &__secondary {
    font-family: "ClanPro";
    color: $grisfonce;
    font-size: 14px;
    margin-bottom: 0;
    span.bleu {
      color: $color1;
      font-family: "ClanPro";
      font-size: 14px;
    }
  }
  &--unavailability {
    strong {
      display: inline-block;
    }
  }
  .delete {
    width: 16px;
    vertical-align: top;
    margin-left: 20px;
    margin-top: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Security/profile.vue